import { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MapPinIcon, MenuIcon, PhoneIcon, SearchIcon, ShoppingCartIcon } from 'lucide-react';
import { business, images, navigation, routes } from '../data/site';
import { MobileMenu } from './MobileMenu';
import { SiteLink } from './SiteLink';
export function Header() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function onPointerDown(event: MouseEvent) {
      if (navRef.current && !navRef.current.contains(event.target as Node)) {
        setOpenIndex(null);
      }
    }
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpenIndex(null);
    }
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);
  return <header className="relative z-40 w-full bg-white" data-id="element-54" data-mp="2wihx1vqug6j7">
      <div className="w-full bg-ink" data-id="element-55" data-mp="2rkq91ctbl4ka">
        <div className="mx-auto flex max-w-container flex-col gap-1 px-5 py-2 sm:px-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-56" data-mp="2rnuesemfo8d2">
          <p className="text-[13.5px] leading-5 text-white sm:text-[14px]" data-id="element-57" data-mp="2ho3l2f5p5xe1">{business.localBar}</p>
          <div className="hidden shrink-0 items-center gap-5 lg:flex" data-id="element-58" data-mp="3fbvjfcghr4n7">
            <a href={business.phoneHref} className="inline-flex items-center gap-1.5 text-[14px] font-medium text-white transition-colors duration-150 ease-out hover:text-water" data-id="element-59" data-mp="3fd6nzehrggfd">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="30mpqu7c5scoa" />
              Call or text {business.phone}
            </a>
            <SiteLink to={routes.location} className="inline-flex items-center gap-1.5 text-[14px] font-medium text-white transition-colors duration-150 ease-out hover:text-water" data-id="element-61" data-mp="1xhd7s4jarvy">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="1re34nr0oekdr" />
              Directions
            </SiteLink>
          </div>
        </div>
      </div>

      <div className="border-b border-ink/10 bg-white" data-id="element-63" data-mp="1ho9xr3bhatfu">
        <div className="mx-auto flex max-w-container items-center justify-between gap-4 px-5 py-3 sm:px-8" data-id="element-64" data-mp="1hlnq73ol8dxm">
          <SiteLink to={routes.home} className="shrink-0" aria-label="Pegasus Spas and Leisure Products home" data-id="element-65" data-mp="1mki53ujfpicg">
            <img src={images.logo} alt="Pegasus Spas & Leisure Products, since 1977" className="h-11 w-auto lg:h-[58px]" width={352} height={140} data-id="element-66" data-mp="1cpghx48pyqci" />
          </SiteLink>

          <div ref={navRef} className="hidden flex-1 items-center justify-end gap-6 lg:flex" data-id="element-67" data-mp="2t2x65g8icnu6">
            <nav aria-label="Main" data-id="element-68" data-mp="2y201ua2llhph">
              <ul className="flex flex-nowrap items-center gap-1" data-id="element-69" data-mp="2y29q9t7zvgt2">
                {navigation.map((item, index) => {
                const isOpen = openIndex === index;
                const panelId = `nav-panel-${index}`;
                return <li key={item.label} className="relative" onMouseEnter={() => item.children && setOpenIndex(index)} onMouseLeave={() => item.children && setOpenIndex(null)} data-id="element-70" data-mp="hdqpax4qotmk" data-mpi={index}>
                      <div className="flex items-center" data-id="element-71" data-mp="1578uwbmoj0kh">
                        <SiteLink to={item.href} className="whitespace-nowrap rounded-btn px-2 py-2 text-[15.5px] font-medium text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-72" data-mp="1051ffc2n52de">
                          {item.label}
                        </SiteLink>
                        {item.children && <button type="button" aria-expanded={isOpen} aria-controls={panelId} aria-label={`${item.label} menu`} onClick={() => setOpenIndex(isOpen ? null : index)} className="rounded-btn p-1 text-ink transition-colors duration-150 ease-out hover:text-pegasus-magenta" data-id="element-73" data-mp="3bwng5duoutob">
                            <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="1k8pdp71pp4b6" />
                          </button>}
                      </div>

                      {item.children && <div id={panelId} hidden={!isOpen} className="absolute left-0 top-full z-50 w-64 rounded-card border border-ink/10 bg-white py-2 shadow-lg" data-id="element-75" data-mp="1t7sycfgj1rrs">
                          <ul data-id="element-76" data-mp="15j1fieotulro">
                            {item.children.map(child => <li key={child.label} data-id="element-77" data-mp="xzidsr7t03tr">
                                <SiteLink to={child.href} className="block px-4 py-2 text-[15px] text-ink transition-colors duration-150 ease-out hover:bg-water hover:text-pegasus-blue" data-id="element-78" data-mp="xz8o74qo7yol">
                                  {child.label}
                                </SiteLink>
                              </li>)}
                          </ul>
                        </div>}
                    </li>;
              })}
                <li data-id="element-79" data-mp="5bwa7iyksz6w">
                  <SiteLink to={routes.specials} className="whitespace-nowrap rounded-btn px-2 py-2 text-[15.5px] font-bold text-pegasus-magenta transition-colors duration-150 ease-out hover:text-[#bb2f83]" data-id="element-80" data-mp="5bcqpxta22qr">
                    Specials
                  </SiteLink>
                </li>
              </ul>
            </nav>

            <div className="flex items-center gap-2 border-l border-ink/10 pl-4" data-id="element-81" data-mp="3dsassb17ovre">
              <button type="button" title="Search" aria-label="Search" className="rounded-btn p-2 text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-82" data-mp="3it872cj3p5nm">
                <SearchIcon className="h-5 w-5" aria-hidden="true" data-id="element-83" data-mp="38w3kwcp99a6t" />
              </button>
              <button type="button" title="Cart" aria-label="Cart" className="rounded-btn p-2 text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-84" data-mp="ez7mhzwbr85">
                <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-85" data-mp="3rslg543bbs7t" />
              </button>
              <SiteLink to={routes.location} className="ml-1 inline-flex min-h-[44px] items-center whitespace-nowrap rounded-btn bg-pegasus-blue px-4 text-[15px] font-bold text-white transition-colors duration-150 ease-out hover:bg-ink" data-id="element-86" data-mp="jdbjwcm3th7y">
                Visit Showroom
              </SiteLink>
            </div>
          </div>

          <div className="flex items-center gap-1 lg:hidden" data-id="element-87" data-mp="23t9nfypbd8zr">
            <button type="button" title="Search" aria-label="Search" className="flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-88" data-mp="2iip2ihfhfpzm">
              <SearchIcon className="h-5 w-5" aria-hidden="true" data-id="element-89" data-mp="1kwrr13ziskx6" />
            </button>
            <button type="button" title="Cart" aria-label="Cart" className="flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-90" data-mp="1yvrew9f7kvsa">
              <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-91" data-mp="3ad96ybnfg6yz" />
            </button>
            <button type="button" aria-label="Open menu" aria-expanded={mobileOpen} onClick={() => setMobileOpen(true)} className="flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-92" data-mp="369b5huamqk2r">
              <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-93" data-mp="1ibjydp0yw9gf" />
            </button>
          </div>
        </div>
      </div>

      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} data-id="element-94" data-mp="1mcdkqdyrhg77" />
    </header>;
}